__turbopack_context__.v({
  "close": "gyQ99a_close",
  "content": "gyQ99a_content",
  "hamburger": "gyQ99a_hamburger",
  "homepage": "gyQ99a_homepage",
  "link": "gyQ99a_link",
  "links": "gyQ99a_links",
  "menu": "gyQ99a_menu",
  "motto": "gyQ99a_motto",
});
